import { Component, OnInit, Input } from "@angular/core";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";

addMore(Highcharts);

@Component({
  selector: "widget-loader",
  templateUrl: "./widget-loader.component.html",
  styleUrls: ["./widget-loader.component.scss"]
})
export class WidgetLoaderComponent implements OnInit {
  @Input() errormessage = "";
  @Input() showloader = false;
  @Input() chartOptions = null;
  @Input() chartOptions2 = null;
  @Input() changeCss = false;
  highcharts: typeof Highcharts = Highcharts;

  constructor() {}

  ngOnInit() {}
}
